var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14H14V23H18.5V14Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.5H14V36.5H18.5V27.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14H27.5V23H32V14Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27.5H27.5V36.5H32V27.5Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 41H14V50H18.5V41Z",
    fill: "#030712"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41H27.5V50H32V41Z",
    fill: "#030712"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 27.5C63.5 26.3 63.02 25.16 62.18 24.32C61.34 23.48 60.2 23 59 23H45.5V5C45.5 3.8 45.02 2.66 44.18 1.82C43.34 0.98 42.2 0.5 41 0.5H5C3.8 0.5 2.66 0.98 1.82 1.82C0.98 2.66 0.5 3.8 0.5 5V63.5H63.5V27.5ZM5 5H41V59H5V5ZM45.5 59V27.5H59V59H45.5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompany);
export default __webpack_public_path__ + "static/media/ic-company.58b2a67ab095bc8824af008f75f13327.svg";
export { ForwardRef as ReactComponent };